// extracted by mini-css-extract-plugin
module.exports = {"iframe_wrapper":"iframe_iframe_wrapper__1h2Z5","credit_wrapper":"iframe_credit_wrapper__9F8fc","iframe":"iframe_iframe__30ukU"};